/*
 * 催收机器人
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { PSDashboardReq, PSGroupStatsReq, ListPhoneSaleStatsReq } from "@/pbjs/xcommon/ticket_pb";
import { Page, timeFormat, setMetaData } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";


export interface Options {
    setUserid?: number,
    Itemid?: string,

}
export interface OptionsTwo {
    Page: Page;
    prop: number;
    order: number;
    Statstype?: number
    Email?: string,
    Username?: string,
    Usergroupid?: string,
    Itemid?: string,
    Timerange?: string,
    Hour?: string,
    Employeeid?: string,
}
export function getPSDashboardReq(arg: Options) {
    let request: any = new PSDashboardReq();

    request.setUserid(arg.setUserid)
    console.log(request, 'PSDashboardReq')
    return request;
}
//  获取数据
export const getPSDashboardRequest = new InnerRequest(
    ticketClient,
    ticketClient.pSDashboard
);
//获取列表dashboard
export function getPSGroupStatsReq(arg: Options) {
    let request: any = new PSGroupStatsReq();

    request.setUserid(arg.setUserid)
    request.setItemid(arg.Itemid);
    console.log(request, 'getPSGroupStatsReq')
    return request;
}
//  获取数据
export const getPSGroupStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.pSGroupStats
);

//获取数据列表列表页
export function getListPhoneSaleStatsReq(arg: OptionsTwo) {
    let request: any = new ListPhoneSaleStatsReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
    request.setStatstype(arg.Statstype);
    request.setEmail(arg.Email);
    request.setUsername(arg.Username);
    request.setEmployeeid(arg.Employeeid);
    request.setUsergroupid(arg.Usergroupid);
    request.setItemid(arg.Itemid);
    request.setTimerange(arg.Timerange);
    console.log(request, 'ListPhoneSaleStatsReq')
    return request;
}
//  获取数据
export const getListPhoneSaleStatsRequest = new InnerRequest(
    ticketClient,
    ticketClient.listPhoneSaleStats
);
// //下载数据列表列表页
export function getListPhoneSaleStatsExcelReq(arg: OptionsTwo, obj: any) {
    return new Promise((resolve, reject) => {
        (async () => {
            let request: any = new ListPhoneSaleStatsReq();
            request.setCommonin(setCommon());
            request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize, arg.prop, arg.order));
            request.setStatstype(arg.Statstype);
            request.setEmail(arg.Email);
            request.setUsername(arg.Username);
            request.setUsergroupid(arg.Usergroupid);
            request.setEmployeeid(arg.Employeeid);
            request.setItemid(arg.Itemid);
            request.setTimerange(arg.Timerange);
            console.log(request, 'getListPhoneSaleStatsExcelReq')
            const res = await ticketClient.listPhoneSaleStatsExcel(
                request,
                setMetaData()
            );
            console.log(res, "res---------------");
            res.on("data", function (response: any) {
                console.log(response, "pipe----");
                // 字节流不存在并状态为1时,表示传输完成, 返回数据
                resolve(response);
            });
            res.on("err", function (err: any) {
                console.log("err: ", err);
                reject(err);
            });
        })();
    })
        .then((response: any) => {
            response.loading = false;
            console.log(response, "getListPhoneSaleStatsExcel");
            handleResponse(response, null);
            return response;
        })
        .catch((err: any) => {
            errorMsg(err);
        });

}